<template>
  <div class="c-newsletterFooter">
    <div
      class="o-btn o-btn--blue c-newsletterFooter__button"
      @click="openForm()"
      v-if="isButton"
    >
      <iArrow />
      <p>TILMELD NYHEDSBREV</p>
    </div>
    <div
      v-if="isForm"
      class="c-newsletterFooter__form"
      v-click-away="openButton"
    >
      <div class="input__wrapper">
        <input
          class="input"
          type="email"
          name="email"
          v-model="email"
          ref="formInput"
          :class="{
            'input--filled': email,
          }"
        />
        <div class="input__label">E-mail</div>
      </div>
      <div class="input__submit" @click="SignUp()">
        <iArrow />
      </div>
    </div>
    <div
      class="o-btn o-btn--blue c-newsletterFooter__button"
      @click="toButton()"
      v-if="isSuccess"
    >
      <iArrow />
      <p>TAK FOR TILMELDINGEN</p>
    </div>
    <div
      class="o-btn o-btn--blue o-btn--back c-newsletterFooter__button"
      @click="toForm()"
      v-if="isFail"
    >
      <iArrow />
      <p>{{ message }}</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mixin as VueClickAway } from 'vue3-click-away';

// Store
import { mapState } from 'pinia';
import { useSiteStore } from '../stores/siteStore';

import iArrow from '@web/assets/icon/btnArrow.svg';

export default {
  name: 'NewsletterSignup',
  mixins: [VueClickAway],
  components: {
    iArrow,
  },
  props: {},
  data: () => {
    return {
      isLoading: false,
      isButton: true,
      isForm: false,
      isFail: false,
      isSuccess: false,
      email: '',
      message: '',
    };
  },
  computed: {
    ...mapState(useSiteStore, ['csrf']),
  },
  methods: {
    openForm() {
      this.isButton = false;
      this.isForm = true;
      this.$nextTick(() => {
        this.$refs.formInput.focus();
      });
    },
    openButton() {
      this.isForm = false;
      this.isButton = true;
    },
    SignUp() {
      this.isLoading = true;

      const formData = new FormData();
      formData.append('action', 'quantity-ubivox/newsletter/signup');
      formData.append('CRAFT_CSRF_TOKEN', this.csrf);
      formData.append('email', this.email);
      // formData.append('header', 'Access-Control-Allow-Origin')

      axios.post(document.location.href, formData).then((res) => {
        this.isLoading = false;
        this.isForm = false;

        if (res.data.success) {
          this.isSuccess = true;
          return;
        }

        this.message = res.data.error ?? 'Der skete en fejl, prøv igen';
        this.isFail = true;
      });
    },
    toForm() {
      this.isFail = false;
      this.isSuccess = false;
      this.isForm = true;
      this.isButton = false;
      this.message = '';
      this.email = '';
    },
    toButton() {
      this.isFail = false;
      this.isSuccess = false;
      this.isForm = false;
      this.isButton = true;
      this.message = '';
      this.email = '';
    },
  },
};
</script>

<style lang="scss">
@import '@backend/scss/abstracts/variables.scss';

.c-newsletterFooter {
  border: 2px solid $c-darkblue;
  height: 46px;
  border-radius: 50px;
  min-width: 250px;

  &__button {
    cursor: pointer;
    margin-right: 0;
    width: 100% !important;
  }

  .o-btn--blue {
    border: none;
  }

  &__form {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;

    .input {
      &__wrapper {
        height: 100%;
        position: relative;
        width: calc(100% - 40px);
      }
      height: 100%;
      padding-top: 12px;
      padding-left: 17px;
      background-color: transparent;
      border: none;
      font-size: 16px;

      &__label {
        position: absolute;
        top: 12px;
        left: 17px;
        font-size: 13px;
        font-weight: $f-bold;
        letter-spacing: -0.13px;
        line-height: 18px;
        color: $c-darkblue;
        // color: $c-medium-grey;
        pointer-events: none;
        touch-action: none;
        transition: all 0.3s $t-nice;
        text-transform: uppercase;
      }

      &:focus,
      &--filled {
        ~ .input__label {
          top: 2px;
          left: 17px;
          font-size: 9px;
          font-weight: 700;
          letter-spacing: -0.07px;
        }
      }
      &__submit {
        cursor: pointer;
        width: 40px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        padding-right: 18px;
        padding-left: 19px;
        transition: all 0.4s cubic-bezier(0.46, 0.04, 0.13, 0.59);

        svg {
          height: 16px;
          width: 16px;
          min-width: 16px;
          min-height: 16px;
          margin-right: 10px;
          .fill {
            fill: $c-darkblue;
          }
          .hover {
            transition: all 0.4s cubic-bezier(0.46, 0.04, 0.13, 0.59);
          }
        }
        &:hover {
          padding-right: 23px;
          padding-left: 15px;
          svg {
            transition: all 0.4s cubic-bezier(0.46, 0.04, 0.13, 0.59);
            .hover {
              transition: all 0.4s cubic-bezier(0.46, 0.04, 0.13, 0.59);
              opacity: 0;
            }
          }
        }
      }
    }
  }
}

// v1
// .c-newsletterSignup{

// 		.input{
// 			width: calc(100% - 70px);
// 			height: 100%;
// 			position: relative;
// 			&__wrapper{
// 				margin-top: 24px;
// 				border: 2px solid $c-white;
// 				// padding: 25px 13px 13px 25px;
// 				border-radius: 50px;
// 				box-sizing: border-box;
// 				height: 46px;
// 				display: flex;
// 			}
// 			&__input{
// 				width: 100%;
// 				height: 46px;
// 				padding-left: 25px;
// 				padding-top: 11px;
// 				font-size: 13px;
// 				line-height: 16px;
// 				letter-spacing: -0.13px;
// 				font-weight: $f-bold;
// 				color: $c-white;
// 				background-color: transparent;
// 				border: none;

// 				&:focus,
// 				&--filled {
// 					~ .input__label {
// 						top: 3px;
// 						left: 25px;
// 						font-size: 9px;
// 						font-weight: 700;
// 						letter-spacing: -0.07px;
// 						text-transform: uppercase;
// 					}
// 				}

// 				&--error {
// 					border-color: #c32121;
// 				}
// 			}
// 			&__label{
// 				position: absolute;
// 				top: 12px;
// 				left: 25px;
// 				font-size: 13px;
// 				font-weight: $f-bold;
// 				letter-spacing: -0.13px;
// 				line-height: 18px;
// 				color: $c-white;
// 				// color: $c-medium-grey;
// 				pointer-events: none;
// 				touch-action: none;
// 				transition: all 0.3s $t-nice;
// 			}

// 			&__submit{
// 				height: 100%;
// 				display: flex;
// 				align-items: center;
// 				width: 50px;
// 				flex: 1;
// 				justify-content: flex-end;
// 				// background-color: red;
// 				padding-right: 20px;
// 				padding-left: 20px;
// 				transition: all 0.4s cubic-bezier(0.46, 0.04, 0.13, 0.59);
// 				cursor: pointer;
// 				svg{
// 					.fill{
// 						fill: $c-white;
// 					}

// 					height: 16px;
// 					width: 16px;
// 					.hover{
// 						transition: all 0.4s cubic-bezier(0.46, 0.04, 0.13, 0.59);
// 					}
// 				}
// 				&:hover{
// 					// padding: 13px 46px 13px 14px;
// 					padding-right: 28px;
// 					padding-left: 12px;
// 					svg{
// 						transition: all 0.4s cubic-bezier(0.46, 0.04, 0.13, 0.59);
// 						.hover{
// 							transition: all 0.4s cubic-bezier(0.46, 0.04, 0.13, 0.59);
// 							opacity: 0;
// 						}
// 					}
// 				}
// 			}
// 		}
// 	}
// }
</style>
../stores/siteStore
